export default "__VITE_ASSET__BHX4QvpL__"